<div class="wk8-panel-image" style="position: relative; width: 100%; height: 100%">
  <div style="position: relative; overflow: hidden; width: 100%; height: 100%; border-radius: 1em; border: 4px solid #3f454e">
    @let image = word().image;
    @if (image) {
      <img [src]="image.url" alt="" style="width: 100%; height: 100%; object-fit: cover" />
    } @else {
      <div style="width: 100%; height: 100%; text-align: center; place-content: center">{{ word().word }}</div>
    }
    <div
      class="borders"
      style="
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border-radius: calc(1em - 4px);
        border-top: 0.25em solid rgba(0, 0, 0, 0.5);
        border-left: 0.25em solid rgba(0, 0, 0, 0.5);
        border-bottom: 0.125em solid rgba(255, 255, 255, 0.5);
        border-right: 0.125em solid rgba(255, 255, 255, 0.5);
        mix-blend-mode: overlay;
      "
    ></div>
  </div>
  <wk8-audio-button
    #audioButton
    [audio]="audio()"
    [cc]="word().word"
    (played)="audio.set(getRandomPronunciation())"
    style="position: absolute; width: 30%; height: 30%; bottom: 43%; left: 0; translate: -45%"
  />
</div>
